const routes = [
    {
        path: "/classrooms",
        component: () => import("../pages/Index"),
        component_full_path: 'classroom/pages/Index',
        meta: {
            isAuthenticated: true,
            permission: 'classroom_index'
        }
    }
];

export default routes;
